"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./form"), exports);
tslib_1.__exportStar(require("./text"), exports);
tslib_1.__exportStar(require("./colors"), exports);
tslib_1.__exportStar(require("./errors"), exports);
tslib_1.__exportStar(require("./image"), exports);
tslib_1.__exportStar(require("./objects"), exports);
tslib_1.__exportStar(require("./operations"), exports);
tslib_1.__exportStar(require("./operators"), exports);
tslib_1.__exportStar(require("./rotations"), exports);
tslib_1.__exportStar(require("./sizes"), exports);
tslib_1.__exportStar(require("./PDFPageOptions"), exports);
tslib_1.__exportStar(require("./PDFDocumentOptions"), exports);
tslib_1.__exportStar(require("./StandardFonts"), exports);
var PDFDocument_1 = require("./PDFDocument");
Object.defineProperty(exports, "PDFDocument", { enumerable: true, get: function () { return PDFDocument_1.default; } });
var PDFFont_1 = require("./PDFFont");
Object.defineProperty(exports, "PDFFont", { enumerable: true, get: function () { return PDFFont_1.default; } });
var PDFImage_1 = require("./PDFImage");
Object.defineProperty(exports, "PDFImage", { enumerable: true, get: function () { return PDFImage_1.default; } });
var PDFPage_1 = require("./PDFPage");
Object.defineProperty(exports, "PDFPage", { enumerable: true, get: function () { return PDFPage_1.default; } });
var PDFEmbeddedPage_1 = require("./PDFEmbeddedPage");
Object.defineProperty(exports, "PDFEmbeddedPage", { enumerable: true, get: function () { return PDFEmbeddedPage_1.default; } });
var PDFJavaScript_1 = require("./PDFJavaScript");
Object.defineProperty(exports, "PDFJavaScript", { enumerable: true, get: function () { return PDFJavaScript_1.default; } });
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/pdf-lib/cjs/api/index.js